import { useMemo } from 'react';
import { useObjectExtraFields } from './useObjectExtraFields';
import { getExtraFieldInputName } from './logic';
import {
  mapFormValueToInternalValue,
  toDisplayValue,
} from './extraFieldInternalValue';
import { ExtraFieldsFormId, ExtraFieldsSupportedObject } from './types';

export type ExtraFieldPreviewItem = {
  label: string;
  value: string;
};

export const useExtraFieldsPreview = (
  objectApiName: ExtraFieldsSupportedObject | string,
  formId: ExtraFieldsFormId | string,
  formData: Record<string, any> | null,
): ExtraFieldPreviewItem[] => {
  const { getFormFields } = useObjectExtraFields(objectApiName);
  const formFields = getFormFields(formId);

  return useMemo(() => {
    if (!formData || formFields.length === 0) return [];

    return formFields
      .map((field) => {
        const formKey = getExtraFieldInputName(
          field.fieldApiName,
          field.fieldInfo.type,
        );
        const rawValue = formData[formKey];
        if (rawValue === undefined || rawValue === null || rawValue === '') {
          return null;
        }
        const fieldType = field.fieldInfo.type;
        const internalValue = mapFormValueToInternalValue(rawValue, fieldType);
        const displayValue = toDisplayValue({ internalValue, type: fieldType });
        if (!displayValue) {
          return null;
        }
        return {
          label: field.fieldInfo.label,
          value: displayValue,
        };
      })
      .filter((item): item is ExtraFieldPreviewItem => item !== null);
  }, [formData, formFields]);
};
